import React, {Component} from 'react';
import {connect} from 'react-redux';
import Lineups from 'desktop/elements/lineups';

class OptimizationResult extends Component {
    render() {
        return <Lineups />;
    }
}

export default connect(() => ({}))(OptimizationResult);
